// extracted by mini-css-extract-plugin
export default {"version":"VersionInfo_version__F5Q3y","hover":"VersionInfo_hover__bgfVP","inner":"VersionInfo_inner__XQ2Jz","fixed":"VersionInfo_fixed__cxKp-"};